import React from "react";
import useBrandRanking from "../../../query/useBrandRanking";
import BrandRankingList from "./BrandRankingList";

const FILTER = "trendingBrands";

/**
 * 일간 랭킹 페이지
 * @returns {React.JSX.Element|null}
 * @constructor
 */
export default function DayRankingPage() {
  const { brands: dailyBrands, loading } = useBrandRanking(FILTER);

  if (loading) return null;

  return <BrandRankingList ranking={dailyBrands} />;
}
